// (function (Drupal, drupalSettings) {
//   Drupal.behaviors.selectSearch = {
//     attach: function (context, settings) {
//       const selects = context.querySelectorAll(".rechercheform select");
//       selects.forEach((select) => {
//         if (!select.dataset.selectSearchProcessed) {
//           select.dataset.selectSearchProcessed = "true";

//           if (typeof Select2 !== "undefined") {
//             $(select).select2(); // Select2 nécessite jQuery pour fonctionner.
//           }

//           const firstOption = document.querySelector(
//             ".select2-results__options li:first-child"
//           );
//           if (firstOption) {
//             firstOption.addEventListener("click", (e) => {
//               e.stopPropagation();
//             });
//           }
//         }
//       });
//     },
//   };
// })(Drupal, drupalSettings);

// (function (Drupal, drupalSettings) {
//   Drupal.behaviors.selectSearch = {
//     attach: function (context, settings) {
//       const selects = context.querySelectorAll(".rechercheform select");

//       selects.forEach((select) => {
//         if (!select.dataset.selectSearchProcessed) {
//           select.dataset.selectSearchProcessed = "true";

//           // Initialisation de Tom Select
//           const tomSelectInstance = new TomSelect(select, {
//             persist: false,
//             create: false,
//           });

//           // Récupération du wrapper et du placeholder "Service"
//           const wrapper = select.closest(".ts-wrapper");
//           if (!wrapper) return;

//           const placeholderItem = wrapper.querySelector(".ts-control .item");
//           const input = wrapper.querySelector(".ts-control input");

//           // Fonction pour cacher "Service" au focus ou à l'entrée de texte
//           function hidePlaceholder() {
//             if (placeholderItem && input.value.trim() !== "") {
//               placeholderItem.style.display = "none";
//             }
//           }

//           // Fonction pour réafficher "Service" si l'input est vide
//           function showPlaceholder() {
//             if (placeholderItem && input.value.trim() === "") {
//               placeholderItem.style.display = "block";
//             }
//           }

//           // Ajout des événements pour gérer la visibilité du placeholder
//           input.addEventListener("focus", hidePlaceholder);
//           input.addEventListener("input", hidePlaceholder);
//           input.addEventListener("blur", showPlaceholder);
//         }
//       });
//     },
//   };
// })(Drupal, drupalSettings);

(function (Drupal, drupalSettings) {
  Drupal.behaviors.selectSearch = {
    attach: function (context, settings) {
      const selects = context.querySelectorAll(".rechercheform select");

      selects.forEach((select) => {
        if (!select.dataset.selectSearchProcessed) {
          select.dataset.selectSearchProcessed = "true";

          // Initialisation de Tom Select
          const tomSelectInstance = new TomSelect(select, {});

          // Observer les changements dans le dropdown pour capturer les nouveaux éléments
          const observer = new MutationObserver(() => {
            const firstOption = document.querySelector(
              ".ts-dropdown .ts-dropdown-content .option:first-child"
            );
            if (firstOption) {
              firstOption.addEventListener("click", (e) => {
                e.stopPropagation(); // Empêche la fermeture du dropdown au clic
              });
            }
          });

          const dropdown = document.querySelector(".ts-dropdown");
          if (dropdown) {
            observer.observe(dropdown, { childList: true, subtree: true });
          }

          // Ouvrir la liste au clic sur le wrapper
          const wrapper = select.closest(".ts-wrapper");
          if (wrapper) {
            wrapper.addEventListener("click", function (e) {
              if (!tomSelectInstance.isOpen) {
                tomSelectInstance.open(); // Ouvre le menu Tom Select
              }
            });
          }
        }
      });
    },
  };
})(Drupal, drupalSettings);
